import React from 'react'
import useFetch from "../hooks/useFetch";
import {Container, Row, Col} from "react-bootstrap";
import {BlocksRenderer} from "@strapi/blocks-react-renderer";

export default function CurrentTournament() {
    const { loading, error, data } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/current-tournament?populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    if (loading) return <p>loading...</p>
    if (error) return <p>Error :(</p>


    console.log(data)
    return(
        <div>
            <div>
                <Container fluid="md">
                    <Row>
                        <Col>
                            <div style={{float: "left", marginBottom: 20, marginTop: 30}}>
                                <h1>{data.data.Title}</h1>
                            </div>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div style={{float: "left", marginBottom: 20}}>
                                <BlocksRenderer content={data.data.Content}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )

}